export default __webpack_public_path__ + "static/media/smart-file-logger.4d9a16d2.svg";